import isDesktop from '../desktop/isDesktop';
import { HOME_BROWSE_PATH } from '../../constants/paths';

export default function unauthRedirectHandler() {
  return { pathname: isDesktop() ? HOME_BROWSE_PATH : '/' };
}
